import { render, staticRenderFns } from "./virtualLoginPage.vue?vue&type=template&id=282f3d3a"
import script from "./virtualLoginPage.vue?vue&type=script&lang=js"
export * from "./virtualLoginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports